import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import PageHeader from "../components/PageHeader";
import {Form} from "react-final-form";
import {apiGetTurnstile, apiPostTurnstile} from "./Actions";
import Toast from "cogo-toast";
import {DefaultLoader} from "../../../components/DefaultLoader";
import InputField from "../../../FinalForm/InputField";
import SelectField from "../../../FinalForm/SelectField";
import ApiTariffSelectField from "../../../FinalForm/api/ApiTariffSelectField";
import {useSelector} from "react-redux";
import {FiPlus, FiSave} from "react-icons/fi";
import {FilterButton, FieldArrayAddButton, FieldArrayDeleteButton} from "../components/Button";
import {FormCard} from "../components/FormCard";
import ApiDeviceSelectMultiField from "../../../FinalForm/api/ApiDeviceSelectMultiField";
import ApiZoneSelectField from "../../../FinalForm/api/ApiZoneSelectField";
import {FieldArray} from "react-final-form-arrays";
import arrayMutators from "final-form-arrays";
import {getTurnstileTypesToSelect, TURNSTILE_TYPES} from "../enigooTurnstileHelper";
import ApiTurnstileTemplateField from "../../../FinalForm/api/ApiTurnstileTemplateField";
import ApiTurnstileSelectField from "../../../FinalForm/api/ApiTurnstileSelectField";

const TurnstileForm = () => {
    let [loading, setLoading] = useState(false);
    let [saving, setSaving] = useState(false);
    let [data, setData] = useState(null);

    const {id} = useParams();
    const navigate = useNavigate();
    let user = useSelector((state) => state.user);
    let submit;

    useEffect(() => {
        user.activeAreal && getData();
    }, [user.activeAreal]);

    const getData = () => {
        if (id) {
            setLoading(true);
            apiGetTurnstile(user.activeAreal.id, id, (data) => {
                setData(data);
                setLoading(false);
            }, (err) => {
                setLoading(false);
                handleError(err);
                navigate("/turnstile/list");
            });
        }
    };

    const handleError = (err) => {
        let error = "Nepodařilo se načíst data o turniketu.\n";
        switch (err.data) {
            case "TURNSTILE_NOT_FOUND": error += "Turniket nebyl nalezen."; break;
            case "UNKNOWN_ERROR":
            default:
                if (error.startsWith("TARIFF_")) error += "Neznámý tarif";
                else error += "Neznámá chyba.";
        }
        Toast.error(error);
    };

    const onSubmit = (values) => {
        if (!user?.user?.rights?.enigooTurniketsEdit) return;
        setSaving(true);
        let newValues = values;
        if (id) newValues = {...values, turnstileId: id};
        if (newValues.turnstileType === 6) {
            newValues = {...newValues, type: 1};
        }
        apiPostTurnstile(user.activeAreal.id, newValues, (data) => {
            if (data) {
                setData(data);
                setSaving(false);
                navigate("/turnstile/detail/" + data.id);
                Toast.success("Úspěšně uloženo.");
            } else {
                Toast.error("Nepodařilo se uložit turniket.");
                setSaving(false);
            }
        }, (err) => {
            setSaving(false);
            handleError(err);
        });
    };

    const renderSpecialRules = (values) => (
        <div style={{marginTop:"12px"}}>
            <div style={{fontSize: "var(--enigoo-fs-sm)",fontWeight:700,color:"#475569",marginBottom:"8px"}}>Speciální pravidla:</div>
            <FieldArray name={"specialRules"}>
                {({fields}) => (
                    <div style={{display:"flex",flexDirection:"column",gap:"8px"}}>
                        <FieldArrayAddButton
                            text={<><FiPlus size={11}/> Přidat pravidlo</>}
                            onClick={() => fields.push({tariffId: null, source: null, destination: null, openTime: null})}
                        />
                        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(240px,1fr))",gap:"10px"}}>
                            {fields.map((name, index) => (
                                <div key={index} style={{border:"1px solid #e2e8f0",borderRadius:"8px",padding:"10px",background:"#fafafa"}}>
                                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"6px"}}>
                                        <span style={{fontSize: "var(--enigoo-fs-xs)",fontWeight:600,color:"#475569"}}>#{index + 1}</span>
                                        <FieldArrayDeleteButton onClick={() => fields.remove(index)}/>
                                    </div>
                                    <ApiTariffSelectField name={`${name}.tariffId`} isMulti={false} isMandatory={true}/>
                                    <InputField label={"Port příchozí zařízení"} name={`${name}.source`} isMandatory={true} inputType={"number"}/>
                                    <InputField label={"Port odchozí zařízení"} name={`${name}.destination`} isMandatory={true} inputType={"number"}/>
                                    <InputField label={"Open time"} name={`${name}.openTime`} isMandatory={true}/>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </FieldArray>
        </div>
    );

    const renderContentByTurnstileType = (values) => {
        if (values.turnstileType === undefined || values.turnstileType === null) return <></>;
        let content = [];
        if (values.uid) {
            content.push(<InputField key="uid" label={"UID (identita zařízení)"} name={"uid"} isMandatory={false} inputType={"text"} disabled={true}/>);
        }
        content.push(<InputField key="ip" label={values.turnstileType === 6 ? "UID" : "IP adresa"} name={"ipAddress"} isMandatory={true} inputType={"text"}/>);
        content.push(<InputField key="desc" label={"Popis"} name={"description"} isMandatory={true} inputType={"text"}/>);
        content.push(<ApiTariffSelectField key="tariff"/>);
        content.push(<ApiZoneSelectField key="zone" name={"zone"} isMulti={false}/>);
        content.push(<ApiTurnstileSelectField key="linked" name={"linkedTurnstile"} label={"Provázaný turniket"} isMulti={false} withoutIds={id ? [Number(id)] : []}/>);
        if (values.turnstileType !== 6) {
            content.push(<SelectField key="type" name={"type"} options={[
                {label: "Vstup", value: 1},
                {label: "Výstup", value: 0},
                {label: "V areálu (wc apod.)", value: 2}
            ]} label={"Typ"} isMandatory={true}/>);
        }
        content.push(<ApiDeviceSelectMultiField key="devices"/>);
        switch (values.turnstileType) {
            case 0:
                content.push(<ApiTurnstileTemplateField key="template0" name={"turnstileTemplate"} isMulti={false}/>);
                break;
            case 1:
                break;
            case 2:
            case 3:
                content.push(<InputField key="openTime" label={"Open time elvis"} name={"openTime"} isMandatory={false} inputType={"text"}/>);
                content.push(<InputField key="source" label={"Port zařízení - příchozí"} name={"source"} isMandatory={false} inputType={"text"}/>);
                content.push(<InputField key="dest" label={"Port zařízení - odchozí"} name={"destination"} isMandatory={false} inputType={"text"}/>);
                content.push(<div key="specialRules">{renderSpecialRules(values)}</div>);
                break;
            case 4:
                content.push(<ApiTurnstileTemplateField key="template4" name={"turnstileTemplate"} isMulti={false} filterTypes={[8,4]}/>);
                break;
            case 5:
                content.push(<SelectField key="rotate" name={"data.typeRotate"} label={"Směr otáčení"} options={[
                    {value: "R", label: "Vpravo"},
                    {value: "L", label: "Vlevo"},
                ]}/>);
                break;
            case 6:
                break;
            case 7:
                content.push(<ApiTurnstileTemplateField key="template7" name={"turnstileTemplate"} isMulti={false}/>);
                break;
            case 8:
                content.push(<ApiTurnstileTemplateField key="template8" name={"turnstileTemplate"} isMulti={false} filterTypes={[8,4]}/>);
                break;
            default:
                break;
        }
        return content;
    };

    return (
        <>
            <PageHeader crumbs={[{label:"Turnikety", to:"/turnstile/list"}, {label: id ? "Upravit turniket" : "Vytvořit turniket"}]}/>

            {loading ? <DefaultLoader text={"Načítám data turniketu..."}/> : (
                <Form onSubmit={onSubmit} initialValues={data}
                    mutators={{...arrayMutators}}
                    render={({handleSubmit, values, form: {mutators: {push}}}) => {
                        submit = handleSubmit;
                        return (
                            <>
                                <FormCard>
                                    {/* Info box */}
                                    <div style={{background:"#eff6ff",border:"1px solid #bfdbfe",borderRadius:"8px",padding:"12px",marginBottom:"14px",fontSize: "var(--enigoo-fs-sm)",color:"#1e293b"}}>
                                        <div style={{fontWeight:700,fontSize: "var(--enigoo-fs-md)",marginBottom:"6px"}}>Typ (výrobce):</div>
                                        <ul style={{margin:"0 0 8px 0",paddingLeft:"16px"}}>
                                            {TURNSTILE_TYPES.map((item, index) => (
                                                <li key={index}><strong>{item.value}</strong> - {item.description}</li>
                                            ))}
                                        </ul>
                                        <div style={{fontWeight:700,fontSize: "var(--enigoo-fs-md)",marginBottom:"6px"}}>Zóna/tarify:</div>
                                        <ul style={{margin:0,paddingLeft:"16px"}}>
                                            <li><strong>Zóna:</strong> Vstupy budou odbavovány vrámci zóny.</li>
                                            <li><strong>Tarify:</strong> Pokud jsou vyplněny tarify, je povolen vstup pouze vstupenkám ve vyplněných tarifech. Pokud není vyplněno budou povoleny vstupy vstupenkám v tarifech, které má přiřazena zóna.</li>
                                        </ul>
                                    </div>

                                    <SelectField name={"turnstileType"} options={getTurnstileTypesToSelect()} label={"Typ (výrobce)"} isMandatory={true}/>
                                    {renderContentByTurnstileType(values)}
                                </FormCard>

                                {user?.user?.rights?.enigooTurniketsEdit && (
                                    <FilterButton type="button" onClick={handleSubmit} loading={saving} text="Uložit" icon={<FiSave size={12}/>} fullWidth/>
                                )}
                            </>
                        );
                    }}
                />
            )}


        </>
    );
};
export default TurnstileForm;
